<script>
  let { showModal = false, title, closeCallback } = $props();

  function close() {
    if (closeCallback && typeof closeCallback === "function") {
      closeCallback();
    }
    showModal = false;
  }
</script>

<div
  class="modal modal-blur fade"
  tabindex="-1"
  class:show={showModal}
  class:d-block={showModal}
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{title}</h5>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          onclick={close}
        ></button>
      </div>

      <slot />
    </div>
  </div>
</div>

<style>
</style>
